export const GET_INITIAL_DATA_SUCCESS = 'GET_INITIAL_DATA_SUCCESS';
export const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';
export const STATE_RESET = 'STATE_RESET';
export const LEGAL_ENTITY_STATE_RESET = 'LEGAL_ENTITY_STATE_RESET';
